export const codeNodes = {
    code_block: {
        group: "block",
        content: "text*",
        marks: "",
        code: true,
        defining: true,
        isolating: true,
        attrs: {
            language: { default: "text" },
            lineWrapping: { default: true },
        },
        parseDOM: [{ tag: "pre", preserveWhitespace: "full" }],
        toDOM(node) {
            const attrs = node.attrs;
            return [
                "pre",
                {
                    class: attrs.lineWrapping
                        ? "code-block--line-wrap"
                        : "code-block--no-line-wrap",
                },
                ["code", 0],
            ];
        },
    },
};
